export default "__VITE_ASSET__BE8Uq6N5__"